import * as React from 'react';
import { CIRCLE_HORIZONTAL_ITEM } from '../../../types/templates/widgets/items/ISkyfireHorizontalItem';
import { bindHandler, buildTags, preventDefault } from '../../../utils';
import { useObserver } from '../../../utils/ObserverHooks';
import ContextMenuButton from '../../ContextMenuButton';
import Button from './Button';
export var HorizontalItemSize;
(function (HorizontalItemSize) {
    HorizontalItemSize[HorizontalItemSize["Small"] = 0] = "Small";
    HorizontalItemSize[HorizontalItemSize["Medium"] = 1] = "Medium";
    HorizontalItemSize[HorizontalItemSize["Large"] = 2] = "Large";
})(HorizontalItemSize || (HorizontalItemSize = {}));
const horizontalItemSizeProperties = {
    [HorizontalItemSize.Small]: 'small',
    [HorizontalItemSize.Medium]: 'medium',
    [HorizontalItemSize.Large]: 'large'
};
/**
 * Calculates horizontal item size based on internal content.
 * @param item horizontal item
 */
export function getItemSize(item) {
    // TODO account for tertiary text once we support this
    let size;
    const hasSecondaryTextAndLabel = item.secondaryText && item.label;
    if (hasSecondaryTextAndLabel) {
        size = getBottomTags(item).length
            ? HorizontalItemSize.Large
            : HorizontalItemSize.Medium;
    }
    else {
        size = HorizontalItemSize.Small;
    }
    return size;
}
/**
 * Returns non-explicit tags, which are displayed on a separate row.
 * @param item horizontal item
 */
function getBottomTags(item) {
    return item.tags.filter(t => t !== 'E');
}
export default function HorizontalItem(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { image, labelText, primaryText, primaryLink, secondaryText, secondaryLink, tertiaryText, tertiaryLink, badgeText, isDisabled, isFeatured, isLocked, label, actionIconName, actionIconLink, iconButton, tags, button, contextMenu, featured, } = props.data;
    const { position } = props;
    const bindHandlerHelper = (fn) => bindHandler(props.handleSelected, null, fn);
    const primaryTextElement = useObserver(primaryText);
    const iconButtonElement = useObserver(iconButton);
    const bottomTags = getBottomTags(props.data);
    return (React.createElement("music-horizontal-item", { key: (primaryTextElement.text || primaryText) + (secondaryText || ''), style: props.style, disabled: isDisabled, featured: isFeatured, locked: isLocked, label: label, "image-src": image, onClick: preventDefault, "label-text": labelText, "primary-text": `${position ? position + '. ' : ''}${primaryTextElement.text || primaryText}`, size: horizontalItemSizeProperties[props.size || HorizontalItemSize.Small], parentSize: horizontalItemSizeProperties[props.parentSize || HorizontalItemSize.Small], kind: props.data.interface === CIRCLE_HORIZONTAL_ITEM ? 'circle' : 'square', "primary-href": (_a = primaryLink) === null || _a === void 0 ? void 0 : _a.deeplink, "icon-name": ((_b = iconButtonElement) === null || _b === void 0 ? void 0 : _b.icon) || actionIconName, "show-action-button": ((_c = iconButtonElement) === null || _c === void 0 ? void 0 : _c.onItemSelected.length) > 0 || !!actionIconLink, onmusicPrimaryTextActivate: bindHandlerHelper((_d = primaryLink) === null || _d === void 0 ? void 0 : _d.onItemSelected), "secondary-text": secondaryText, "secondary-href": (_e = secondaryLink) === null || _e === void 0 ? void 0 : _e.deeplink, "tertiary-text": tertiaryText, "tertiary-href": (_f = tertiaryLink) === null || _f === void 0 ? void 0 : _f.deeplink, "badge-text": badgeText, "bottom-tags": bottomTags, onmusicSecondaryTextActivate: bindHandlerHelper(secondaryLink ? secondaryLink.onItemSelected : []), onmusicActionButtonActivate: bindHandlerHelper(((_g = iconButtonElement) === null || _g === void 0 ? void 0 : _g.onItemSelected) ||
            (actionIconLink ? actionIconLink.onItemSelected : [])) },
        tags.includes('E') ? buildTags(['E'], isDisabled, true) : null,
        button && React.createElement(Button, { data: button, handleSelected: props.handleSelected, slot: "buttons", size: "small" }),
        contextMenu &&
            React.createElement(ContextMenuButton, { options: contextMenu.options, disabled: contextMenu.disabled, slot: 'buttons', variant: 'primary', iconName: 'more', size: "small", onItemSelected: contextMenu.onItemSelected })));
}
;
